module.exports = __webpack_public_path__ + "img/message.8b79de64.svg";